import { useCallback } from 'react';
import type ElementRegistry from 'diagram-js/lib/core/ElementRegistry';
import { useDiagramContext } from '../Context/DiagramContext';
import type { Opportunity } from '../Types/diagram-type';

export const useDiagramBadges = () => {
  const { bpmnModelerRef, aiOpportunityData } = useDiagramContext();

  const updateDiagramBadges = useCallback(() => {
    if (!bpmnModelerRef.current) return;

    try {
      const overlays = bpmnModelerRef.current.get('overlays');
      const elementRegistry = bpmnModelerRef.current.get('elementRegistry') as ElementRegistry;

      if (!overlays || !elementRegistry) return;

      const aiOpportunities = (window._aiOpportunityData ||
        aiOpportunityData ||
        []) as Opportunity[];

      const shapeIdCountMap = new Map<string, number>();

      aiOpportunities.forEach((opp: Opportunity) => {
        if (opp.valid === true) {
          shapeIdCountMap.set(opp.shape_id, (shapeIdCountMap.get(opp.shape_id) || 0) + 1);
        } else {
          shapeIdCountMap.set(opp.shape_id, shapeIdCountMap.get(opp.shape_id) || 0);
        }
      });

      // Badge rendering logic can be added here if needed
      // Currently commented out in original code
    } catch (error) {
      console.error('Error updating diagram badges:', error);
    }
  }, [bpmnModelerRef, aiOpportunityData]);

  return {
    updateDiagramBadges,
  };
};
